export default __webpack_public_path__ + "static/0138-25932c8554891b35d0311dce9f4bba22.png";